import React, { Children } from 'react';
import './recipeCollectionGrid.css';

// Round-robin assignment preserves sorted left-to-right placement while each
// column stacks cards at their natural height (no measurements or row tracks).
export default function RecipeCollectionGrid({ children, className = '', ...props }) {
  const columns = [[], [], []];
  Children.toArray(children).forEach((child, index) => {
    columns[index % columns.length].push(child);
  });

  return (
    <div {...props} className={['recipe-collection-grid', className].filter(Boolean).join(' ')}>
      {columns.map((column, index) => (
        <div key={index} className="recipe-collection-grid__column">
          {column}
        </div>
      ))}
    </div>
  );
}
